

















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Events extends Vue {
  @Prop({ default: false }) readonly active!: boolean;
}
